import { Table } from "antd/es";
import React, { useState } from "react";
import { ImageSelector } from "../ImageSelector";


export const NormalizedImageLosses = (props) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const { imageNames, losses, averages } = props;


    return (<>
        <ImageSelector bind={[selectedFile, setSelectedFile]} imageNames={imageNames} />

        {selectedFile && (<>
            {losses[selectedFile] ? <div>
                <Table
                    style={{ marginTop: 12 }}
                    rowKey={"step"}
                    size="small"
                    dataSource={losses[selectedFile].map(v => ({ ...v, rel: v.loss / (averages[v.timestep]?.avg ?? 1.0) }))}
                    columns={[
                        { title: "Training step", dataIndex: "step" },
                        { title: "Timestep", dataIndex: "timestep", sorter: (a, b) => a.timestep - b.timestep },
                        { title: "Loss", dataIndex: "loss", sorter: (a, b) => a.loss - b.loss, render: v => v.toFixed(5) },
                        { title: "Step-relative", sorter: (a, b) => a.rel - b.rel, render: (_, v) => v.rel.toFixed(5) }
                    ]}
                    pagination={{ position: ["bottomCenter"], responsive: true, size: "small" }} />
            </div> :
                <>No entry</>}
        </>)}
    </>);
};
